import { GET_EMPRESAS, CREATE_EMPRESA, UPDATE_EMPRESA, DELETE_EMPRESA } from '../constants/action_types';

const initialState = { empresas: [], isLoading: false, refresh: false, };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_EMPRESAS:
            return {
                empresas: [],
                isLoading: true,
                refresh: false,
            };

        case GET_EMPRESAS + "_SUCCESS":
            return {
                empresas: action.payload.data.map((emp) => {
                   return {...emp,removed:false}
                }),
                isLoading: false,
                refresh: false,
            };

        case CREATE_EMPRESA + "_SUCCESS":

            const newArr = [...state.empresas, action.payload];

            return {
                empresas: newArr,
                isLoading: false,
                refresh: true,
            };

        case UPDATE_EMPRESA + "_SUCCESS":

            return  {
                empresas: state.empresas.map((empresa) => {
                    if (empresa.id !== action.payload.id) return empresa;
                    else return action.payload;
                }),
                isLoading: false,
                refresh: true,
            };
            

        case DELETE_EMPRESA + "_SUCCESS":

            return {
                empresas: state.empresas.map(empresa => {
                    if(empresa.id === action.payload.id) {
                        empresa.removed = true
                    }
                    return empresa;
                }),
                isLoading: false,
                refresh: true,
            };

         

        default:

            return state;
    };
};